<template>
    <div class="direct-home">
        <div class="display-msg">
            <h2 class="section-heading">Latest COVID-19 Update</h2>
            <div class="content">
                Christchurch locally owned and operated
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "app-essential-direct-deliver"
    };
</script>

<style scoped lang="scss">
    .direct-home {
        width: 100%;
        background-color: #2399ff;
        .display-msg {
            width: 98%;
            display: grid;
            grid-template-columns: 200px 1fr;
            padding: .5rem;
            align-items: center;
            justify-items: start;
            .section-heading {
                margin-bottom: 0.5em !important;
                font-size: .9rem;
                color: #ffffff;
                font-weight: 500;
            }

            .content {
                font-size: .75rem;
                line-height: 1.75em;
                color: #fff;
                font-weight: 400;
                padding-bottom: 0.5em;
            }

            @media all and (max-width: 768px) {
                width: 96%;
                grid-template-columns: 1fr;
                justify-items: self-start;
                .section-heading {
                    font-size: 1rem;
                }
                .content {
                    font-size: .85rem;
                    line-height: 1.5rem;
                }
            }
        }
    }
</style>
